// load environmental variables
export const MUMBAI_CONTRACT_ADDRESS =
  process.env.REACT_APP_MUMBAI_CONTRACT_ADDRESS || "";
export const MUMBAI_WEBSOCKET_HOST =
  process.env.REACT_APP_MUMBAI_WEBSOCKET_HOST || "";
export const LOCAL_CONTRACT_ADDRESS =
  process.env.REACT_APP_LOCAL_CONTRACT_ADDRESS || "";
